module.exports = __webpack_public_path__ + "img/icon-info.14de3d74.svg";